global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';

$(document).ready(function() {

    if (navigator.userAgent.match(/(iPhone|iPad)/)) {
        if($("#indicazioni a")) {
            $("#indicazioni a").attr("href", "http://maps.apple.com/?daddr=Via+Teatro+Vecchio+4+30171+Mestre+Venezia+Italia&z=19");
        }
    } else {
        if($("#indicazioni a")) {
            $("#indicazioni a").attr("href","https://maps.app.goo.gl/A1g7b4eW1yekkXbf8");
        }
    }

    // AOS animations
    $(function() {
        AOS.init({
            duration: 600,
            once: true,
        });
    });

    // headroom
    if($('.headroom').length > 0){
        let options = {
            offset: 100 ,
            // tolerance : 50
            // css
        }
        let headroomEl = document.querySelector("header");
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    // MENU
    let burgerButton = $('.burger-button');
    let mainMenu = $('.sub-menu-general')
    let btx = $('.bi-x')
    let btmenu = $('.bi-list')
    burgerButton.on( "click", function(event) {
        event.preventDefault()
        if (!burgerButton.hasClass('opened')){
            btx.removeClass('d-none')
            btmenu.addClass('d-none')
            burgerButton.addClass('opened')
            event.preventDefault()
            mainMenu.stop().slideDown('fast');
            $('body').addClass('overflow-hidden')
            event.stopPropagation()
        } else {
            event.preventDefault()
            btx.addClass('d-none')
            btmenu.removeClass('d-none')
            burgerButton.removeClass('opened')
            event.preventDefault()
            mainMenu.stop().slideUp('fast');
            $('body').removeClass('overflow-hidden')
            event.stopPropagation()
        }
    });
});
